import { SortDirection } from '@angular/material/sort';
import { createAction, props } from '@ngrx/store';

import { BusinessPartner, PaginationState } from '../../models/business-partner-backoffice.model';

export const clearBusinessPartnerResult = createAction(
  '[BusinessPartners] Clear BusinessPartners Result',
);

export const businessPartnersNotFound = createAction(
  '[BusinessPartners] BusinessPartners not found',
);

export const getBusinessPartners = createAction(
  '[BusinessPartners] Get BusinessPartners by keyword',
  props<{ keyword: string; currentPage: number; currentPageSize: number; sort: SortDirection }>(),
);

export const getBusinessPartnersSuccess = createAction(
  '[BusinessPartners] Get BusinessPartners Success',
  props<{ businessPartners: BusinessPartner[]; pagination: PaginationState }>(),
);
